import React from 'react';

export default function ImageIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.875 6.375H4.125V17.625H19.875V6.375Z"
        stroke={color}
        strokeWidth="0.75"
      />
      <path
        d="M15.75 12.375C16.7855 12.375 17.625 11.5355 17.625 10.5C17.625 9.46447 16.7855 8.625 15.75 8.625C14.7145 8.625 13.875 9.46447 13.875 10.5C13.875 11.5355 14.7145 12.375 15.75 12.375Z"
        stroke={color}
        strokeWidth="0.75"
      />
      <path
        d="M4.125 13.125L8.625 8.625L15.75 15.75L18 13.5L19.815 15.315"
        stroke={color}
        strokeWidth="0.75"
      />
    </svg>
  );
}
